import { Component, OnInit } from '@angular/core';

// Variables Globales
import { Globals } from '../../services/global/global';
import { MenuService } from '../../services/menu/menu.service';
import { AlarmasService } from 'src/app/services/eventos/alarmas.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  MENU: any = [];

  url1: string;
  url2: string;
  ubicacion: string;

  constructor(
    public globals: Globals,
    public menuService: MenuService,
    public alarmasService: AlarmasService
  ) { }

  ngOnInit() {
    this.globals.verticalNavType = 'offcanvas';
    this.menuService.cargarMenu();

  }

  onClickedOutsideSidebar(e: Event) {
    if ((this.globals.windowWidth < 992
      && this.globals.toggleOn
      && this.globals.verticalNavType !== 'offcanvas')
      || this.globals.verticalEffect === 'overlay') {
      this.globals.toggleOn = true;
      this.globals.verticalNavType = 'offcanvas';
    }
  }

  ubicacion1(item) {
    this.url1 = item.state;
  }

  ubicacion2(item) {
    this.url2 = item.state;

    this.ubicacion = this.url1 + '/' + this.url2;
    // console.log(this.ubicacion);

    // this.alarmasService.sendUbicacion(this.ubicacion);
  }

}
